import { Location, State } from 'history';
import UrlSearchParamKey from '../constants/urlSearchParamKey';

export default function getUrlParam<T>(location: Location<State>, key: UrlSearchParamKey) {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(key) as T | null;
}
